import type { JSX } from "react";

import { Popover } from "@mantine/core";

import { DialpadIcon, IconButton } from "@/common-ui";

import { useControlsStore } from "../controls.store";
import { Dialpad } from "../Dialpad";

export function ToggleDialpadButton(): JSX.Element {
    const { dialpadOpen, isMuted, toggleDialpadActive } = useControlsStore();

    const isDisabled = isMuted;
    return (
        <Popover
            opened={dialpadOpen}
            position="bottom"
            zIndex="var(--mantine-priority-highest)"
            styles={{
                dropdown: {
                    backgroundColor: "transparent",
                    border: "none",
                    padding: 0,
                },
            }}
        >
            <Popover.Target>
                <IconButton
                    active={dialpadOpen}
                    analytics={{
                        actionId: "ToggleDialpadButton",
                    }}
                    aria-label="Dialpad"
                    data-testid="call-controls-dialpad-toggle"
                    onClick={toggleDialpadActive}
                    disabled={isDisabled}
                    radius="xl"
                    size="30"
                    tooltip={isDisabled ? "Disabled while muted" : "Dialpad"}
                    style={{
                        backgroundColor: dialpadOpen ? "var(--mantine-color-white)" : "transparent",
                    }}
                >
                    <DialpadIcon
                        height={15}
                        stroke={dialpadOpen ? "var(--mantine-color-black)" : "var(--mantine-color-white)"}
                    />
                </IconButton>
            </Popover.Target>
            <Popover.Dropdown>
                <Dialpad />
            </Popover.Dropdown>
        </Popover>
    );
}
